module.exports = __webpack_public_path__ + "img/10_zh.99a2c4df.png";